module.exports = __webpack_public_path__ + "img/1345483321.cac7688a.jpg";